export enum InterfaceLimitationEnum {
  DenyShowFiles = 'DenyShowFiles',
  DenyShowReceived = 'DenyShowReceived',
  DenyShowShared = 'DenyShowShared',
  DenyShowFavorites = 'DenyShowFavorites',
  DenyShowHidden = 'DenyShowHidden',
  DenyShowTrash = 'DenyShowTrash',
  DenyShowUsers = 'DenyShowUsers',
  DenyShowGroups = 'DenyShowGroups',
  DenyShowSettings = 'DenyShowSettings',
  DenyShowActivities = 'DenyShowActivities',
  DenyShowCreateNewFileFolder = 'DenyShowCreateNewFileFolder',
  DenyShowCreateNewUser = 'DenyShowCreateNewUser',
  DenyShowCreateNewGroup = 'DenyShowCreateNewGroup',
  DenyShowTags = 'DenyShowTags',
  DenyCompanyTag = 'DenyCompanyTag'
}

// // Interface
// [Category(eSettingCategory.Interface)]
// DenyShowFiles,
// [Category(eSettingCategory.Interface)]
// DenyShowReceived,
// [Category(eSettingCategory.Interface)]
// DenyShowShared,
// [Category(eSettingCategory.Interface)]
// DenyShowFavorites,
// [Category(eSettingCategory.Interface)]
// DenyShowHidden,
// [Category(eSettingCategory.Interface)]
// DenyShowTrash,
// [Category(eSettingCategory.Interface)]
// DenyShowUsers,
// [Category(eSettingCategory.Interface)]
// DenyShowGroups,
// [Category(eSettingCategory.Interface)]
// DenyShowSettings,
// [Category(eSettingCategory.Interface)]
// DenyShowActivities,
// [Category(eSettingCategory.Interface)]
// DenyShowCreateNewFileFolder,
// [Category(eSettingCategory.Interface)]
// DenyShowCreateNewUser,
// [Category(eSettingCategory.Interface)]
//             DenyShowCreateNewGroup,
